import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Checkbox,
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridRowId,
  GridSelectionModel,
} from "@mui/x-data-grid";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import { motion } from "framer-motion";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ProductList = () => {
  const [simData, setSimData] = useState<any[]>([]);
  const [countryListN, setCountryListN] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [checked, setChecked] = useState<boolean>(false);
  const [country, setCountry] = useState<any>("0");
  const [product, setProduct] = useState<any>("0");
  const [currency, setCurrency] = useState<any>("0");
  const [action, setAction] = useState<any>("1");
  const [vendor, setVendor] = useState<any>("0");
  const [rowData, setRowData] = useState<any[]>([]);
  const [fullData, setFullData] = useState<any[]>([]);
  const [operator, setOperator] = useState<any>(0);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [selectedProducts, setSelectedProducts] = useState<any[]>([]);
  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [perform, setPerform] = useState<boolean>(false);

  const [paginationModel, setPaginationModel] = useState<any>({
    page: 1,
    pageSize: 50,
  });
  const isFirstRender = useRef(true);
  const baseURL = process.env.REACT_APP_Fusion_Hub_API_URL;
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("user")) {
      var user = JSON.parse(localStorage.getItem("user") || "");
      if (user.Email == "tahir.shahzad@now.net.pk") {
        navigate("/fusionhub/product-list");
      } else {
        navigate("/support/portin");
      }
    }
  }, []);

  const loadCountries = async () => {
    await fetch("/data/thacountry.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.json();
      })
      .then((json: any) => {
        setCountryListN(json.thacountries);
      });
  };

  useEffect(() => {
    loadCountries();
    getOperator();
  }, []);

  const getProductData = () => {
    setPaginationModel((prev: any) => ({
      ...prev,
      page: 1,
    }));
  };
  const sortOperators = (operators: any[]) => {
    return operators.sort((a, b) =>
      a.operator?.operatorName.localeCompare(b.operator?.operatorName)
    );
  };

  useEffect(() => {
    const filterOperators = () => {
      const filteredData = fullData.filter((item: any) => {
        const matchesCountry =
          country !== "0" && country !== undefined
            ? item.country.countryIsoCode === country.isoCode2
            : true;

        return matchesCountry;
      });
      const filteredOperators = filteredData.map((item: any) => ({
        operator: item.operator,
        country: item.country,
      }));
      const sortedFilteredOperators = sortOperators(filteredOperators);

      setRowData(sortedFilteredOperators);
    };
    if (fullData.length > 0) {
      filterOperators();
    }
  }, [country]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    getSimData();
  }, [paginationModel]);

  const getOperator = async () => {
    toast.dismiss();
    await axiosInterceptorInstance
      .post(
        `/FusionHubCrm/GetOperators
`,
        {
          page: 1,
          recordsPerPage: 10000,
        }
      )
      .then((response: any) => {
        const responseData = response?.data.payload;

        const operators = responseData.map((item: any) => ({
          operator: item.operator,
          country: item.country,
        }));
        const sortedOperators = sortOperators(operators);
        setFullData(responseData);
        setRowData(sortedOperators);
        if (rowData.length == 0) {
          //toast.error("No Record Found");
          //setCircular(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getSimData = async () => {
    setIsLoading(true);
    setSimData([]);
    setChecked(false);

    await axiosInterceptorInstance
      .post(`/FusionHubCrm/GetProducts`, {
        page: paginationModel.page,
        recordsPerPage: paginationModel.pageSize,
        filters: {
          isActive: action === "1" ? true : false,
          ...(country !== undefined && { countryIsoCode: country.isoCode2 }),
          ...(operator?.operator?.operatorShortCode
            ? {
                operatorShortCode: operator.operator.operatorShortCode,
              }
            : {}),
          ...(product !== "0" && { categoryShortCode: product }),
          ...(currency !== "0" && { CurrencyCode: currency }),
        },
      })
      .then((response: any) => {
        const responseData = response.data.payload;
        const totalRecords = response.data.paginationInfo.totalCount;
        if (responseData.length == 0 && totalRecords > 0) {
          setPaginationModel((prev: any) => ({
            ...prev,
            page: paginationModel.page - 1,
          }));
        }
        setSimData(responseData);
        setTotalRows(totalRecords);

        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };
  const ActiveOrDeActivation = async () => {
    setPerform(true);
    await axiosInterceptorInstance
      .post(`FusionHubCrm/ActivateOrDeactivateProducts`, {
        products: selectedProducts,
      })
      .then((res: any) => {
        const data = res.data;
        setOpenDialog(false);
        setPerform(false);
        toast.success(data.message);
        getSimData();
      })
      .catch((error: any) => {
        setOpenDialog(false);
        setPerform(false);
      });
  };
  const columns: GridColDef[] = [
    { field: "productId", headerName: "Product ID", width: 150 },
    { field: "productName", headerName: "Product Name", width: 150 },
    { field: "productAliasName", headerName: "Alias", width: 150 },
    { field: "productType", headerName: "Type", width: 100 },
    { field: "categoryShortCode", headerName: "Category", width: 150 },
    { field: "vendorName", headerName: "Vendor", width: 150 },
  ];

  const handleSelectionChange = (newSelection: GridSelectionModel) => {
    setSelectionModel(newSelection);
    setChecked(newSelection.length > 0);

    const selected = newSelection.map((id) => {
      const selectedRow = simData.find((row) => row.product?.productId === id);
      return {
        productId: selectedRow?.product?.productId,
        isActive: !selectedRow?.product?.isActive,
      };
    });

    setSelectedProducts(selected);
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Product List</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            {/* Form Controls */}
            <Grid item xs={12}>
              <fieldset>
                <legend>General Information:</legend>

                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <FormControl fullWidth>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Currency
                      </InputLabel>
                      <Select
                        value={currency}
                        onChange={(e) => setCurrency(e.target.value)}
                      >
                        <MenuItem value="0">Choose Currency</MenuItem>
                        <MenuItem value="USD">USD</MenuItem>
                        <MenuItem value="GBP">GBP</MenuItem>
                        <MenuItem value="EUR">EUR</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    {countryListN && (
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Countries
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={country?.isoCode2 || 0}
                          defaultValue={country?.isoCode2 || 0}
                          onChange={(e: any) => {
                            const country = countryListN?.find(
                              (item) => item.isoCode2 === e.target.value
                            );
                            setCountry(country);
                          }}
                        >
                          <MenuItem value="0">Select Country</MenuItem>
                          {countryListN.map((item, index) => (
                            <MenuItem key={index} value={item?.isoCode2}>
                              {item?.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Product Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={product}
                        defaultValue={product}
                        onChange={(e: any) => {
                          setProduct(e.target.value);
                        }}
                      >
                        <MenuItem value="0">Choose Type</MenuItem>
                        <MenuItem value="gift_cards"> Gift Card </MenuItem>
                        <MenuItem value="mobile">Mobile</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={4}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Operator
                      </InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={operator?.operator?.operatorId || "0"}
                        defaultValue={operator?.operator?.operatorId || "0"}
                        onChange={(e: any) => {
                          const operator = rowData?.find(
                            (item: any) =>
                              item.operator?.operatorId === e.target.value
                          );

                          setOperator(operator);
                        }}
                      >
                        <MenuItem value="0">Choose Type</MenuItem>

                        {rowData.length > 0 ? (
                          rowData.map((item: any, index: any) => (
                            <MenuItem
                              key={index}
                              value={item.operator?.operatorId}
                            >
                              {item.country?.countryIsoCode}
                              {"-"}
                              {item.operator?.operatorName}
                            </MenuItem>
                          ))
                        ) : (
                          <div
                            className="circular-loader"
                            style={{ marginLeft: "0" }}
                          >
                            <CircularProgress size={40} />
                          </div>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Action
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={action}
                        defaultValue={action}
                        onChange={(e: any) => {
                          setAction(e.target.value);
                        }}
                      >
                        <MenuItem value="1">Active</MenuItem>
                        <MenuItem value="0"> InActive</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Vendor
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={vendor}
                        defaultValue={vendor}
                        onChange={(e: any) => {
                          setVendor(e.target.value);
                        }}
                      >
                        <MenuItem value="0">Choose Vendor</MenuItem>
                        <MenuItem value="1">DTOne</MenuItem>
                        <MenuItem value="2">Reloadly</MenuItem>
                        <MenuItem value="3">Ding</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                {rowData.length == 0 && (
                  <div
                    className="circular-loader"
                    style={{ marginLeft: "0px" }}
                  >
                    <CircularProgress size={40} />
                  </div>
                )}
                {rowData.length > 0 && (
                  <Grid>
                    <Button
                      variant="contained"
                      onClick={getProductData}
                      sx={{
                        margin: "0 auto",
                        display: "block",
                        width: "280px !important",
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                )}
              </fieldset>
            </Grid>
          </Grid>
          {isLoading && (
            <div className="circular-loader" style={{ marginLeft: "0px" }}>
              <CircularProgress size={40} />
            </div>
          )}
          {simData?.length > 0 && (
            <>
              <div
                style={{
                  display: checked ? "block" : "none",
                  marginTop: "16px",
                  marginBottom: "5px",
                }}
              >
                <Button
                  className="dButton dButton2"
                  onClick={() => setOpenDialog(true)}
                  variant="contained"
                  sx={{
                    width: "280px !important",
                  }}
                >
                  {simData[0]?.product.isActive === true
                    ? "DeActivate"
                    : "Activate"}
                </Button>
              </div>

              <div style={{ height: 550, width: "100%", marginTop: 16 }}>
                <DataGrid
                  rows={
                    simData?.map((row) => ({
                      ...(row.product || {}), // Ensure product exists, or use an empty object
                      id: row.product?.productId || "no-id", // Fallback if productId is undefined
                    })) || []
                  } // Fallback to empty array if simData is undefined
                  columns={columns}
                  pagination
                  rowCount={totalRows}
                  paginationMode="server"
                  pageSize={paginationModel.pageSize}
                  rowsPerPageOptions={[10, 25, 50]}
                  onPageSizeChange={(newPageSize) =>
                    setPaginationModel((prev: any) => ({
                      ...prev,
                      pageSize: newPageSize,
                    }))
                  }
                  page={paginationModel.page - 1}
                  onPageChange={(newPage) =>
                    setPaginationModel((prev: any) => ({
                      ...prev,
                      page: newPage + 1,
                    }))
                  }
                  checkboxSelection
                  onSelectionModelChange={handleSelectionChange}
                />
              </div>
            </>
          )}
          <Dialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Would you really like to{" "}
                {simData[0]?.product.isActive === true
                  ? "DeActivate"
                  : "Activate"}{" "}
                this?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                className="dButton dButton2 dbuttonSec"
                onClick={() => setOpenDialog(false)}
              >
                No
              </Button>
              <div style={{ width: "30px" }}></div>
              {!perform && (
                <Button
                  variant="contained"
                  className="dButton dButton2"
                  onClick={() => {
                    ActiveOrDeActivation();
                  }}
                  autoFocus
                >
                  Yes
                </Button>
              )}
              {perform && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </DialogActions>
          </Dialog>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductList;
